module.exports = __webpack_public_path__ + "static/media/phone2.3875cc6d.svg";